import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  SET_MOTORBIKE_STATUS,
  SET_MOTORBIKE_STATUS_FAILURE,
  SET_MOTORBIKE_STATUS_SUCCESS,
  FETCH_MOTORBIKES,
  MotorbikeStatus
} from 'src/redux/motorbikesReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'
import { PayloadAction } from '@reduxjs/toolkit'

interface SetMotorbikeStatusPayload {
  id: string
  status: MotorbikeStatus
  name?: string
}

const toastMessage = (status: MotorbikeStatus, name: string): string => {
  const vehicleName = name.trim().length === 0 ? t('my_vehicles.toast_vehicle_fallback') : name.trim()
  if (status === 'sold') {
    return t('my_vehicles.toast_marked_sold', { name: vehicleName })
  }
  return t('my_vehicles.toast_restored_stock', { name: vehicleName })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* SetMotorbikeStatusFlow(action: PayloadAction<SetMotorbikeStatusPayload>): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/motorbikes/${action.payload.id}`
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: PUT,
      params: {
        motorbike: {
          status: action.payload.status
        }
      }
    })
    const payloadName = action.payload.name
    const vehicleName = typeof payloadName === 'string' ? payloadName : ''
    yield put(
      SHOW_TOAST({
        message: toastMessage(action.payload.status, vehicleName)
      })
    )
    yield put(SET_MOTORBIKE_STATUS_SUCCESS())
    yield put(FETCH_MOTORBIKES())
  } catch (error) {
    yield put(SET_MOTORBIKE_STATUS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* MarkMotorbikeAsSoldSaga(): Generator<any, void, any> {
  yield takeLatest(SET_MOTORBIKE_STATUS, SetMotorbikeStatusFlow)
}
